import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { setToken } from '../utils/auth';

const SocialCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { refreshUser } = useAuth();

  useEffect(() => {
    const handleSocialCallback = async () => {
      console.log('소셜 로그인 콜백 처리 시작');
      
      const token = searchParams.get('token');
      const success = searchParams.get('success');
      const errorMessage = searchParams.get('error');

      if (success === 'false' || errorMessage) {
        setError(decodeURIComponent(errorMessage || t('social.loginFailed')));
        setLoading(false);
        return;
      }

      if (token) {
        try {
          // 토큰을 저장하고 사용자 정보 새로고침
          setToken(token);
          await refreshUser();
          
          console.log('소셜 로그인 성공, 사용자 역할에 따라 대시보드로 이동');
          
          // 토큰에서 사용자 정보 추출 (간단한 디코딩)
          let userRole = 'client'; // 기본값
          try {
            const tokenPayload = JSON.parse(atob(token.split('.')[1]));
            userRole = tokenPayload.role || 'client';
            console.log('사용자 역할:', userRole);
          } catch (e) {
            console.log('토큰 디코딩 실패, 기본값 사용:', e);
          }
          
          // 상태 업데이트를 위해 잠시 대기
          setTimeout(() => {
            navigate('/dashboard', { replace: true });
          }, 100);
        } catch (err) {
          console.error('소셜 로그인 처리 실패:', err);
          setError(t('social.processError'));
        }
      } else {
        setError(t('social.noInfo'));
      }
      
      setLoading(false);
    };

    handleSocialCallback();
  }, [searchParams, navigate, refreshUser, t]);

  const goToLogin = () => {
    navigate('/login');
  };

  const goToHome = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        padding: '20px'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px'
        }}>
          🔄
        </div>
        <h2 style={{
          color: '#333',
          marginBottom: '10px'
        }}>
          {t('social.processing')}
        </h2>
        <p style={{
          color: '#666',
          textAlign: 'center'
        }}>
          {t('social.wait')}
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        padding: '20px'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px'
        }}>
          ❌
        </div>
        <h2 style={{
          color: '#dc3545',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          {t('social.failed')}
        </h2>
        <p style={{
          color: '#666',
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          {error}
        </p>
        <div style={{
          display: 'flex',
          gap: '15px'
        }}>
          <button
            onClick={goToLogin}
            style={{
              padding: '12px 24px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            {t('social.retry')}
          </button>
          <button
            onClick={goToHome}
            style={{
              padding: '12px 24px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            {t('social.home')}
          </button>
        </div>
      </div>
    );
  }

  // 성공 시에는 자동으로 리다이렉트되므로 이 부분은 실행되지 않음
  return null;
};

export default SocialCallbackPage;
